import React from "react";
import logo from "./assets/logo.png"

const Header = () => {
  return (
    <div className="header-wrapper text-center">
      <div className="row header-top justify-content-center">
        <div className="col-md-4 pt-3 pb-3">
          <a href="https://www.etsy.com/shop/PersonalizedTouchUSA">
            <img src={logo} className="mono-logo" alt="logo" />
          </a>
        </div>
      </div>
      <div className="row header-bottom pt-3 pb-3 pt-md-5 pb-md-5">
        <div className="col-md-4">
          STEP ONE: Enter your text/name
        </div>
        <div className="col-md-4 offset-md-4">
          STEP TWO: Click "Shop Now"
        </div>
      </div>
    </div>
  );
};

export default Header;


// WEBPACK FOOTER //
// ./src/app/Header/Header.js